import React from "react";

const ModalContext = React.createContext({
  onHide: null,
});

export default ModalContext;
